import LoginSide from '../../modules/loginSide';
import Greetings from '../../modules/greetings';
import './index.css';
import MetaProvider from '../../modules/meta/components/MetaProvider';
import useFavicon from '../../modules/meta/hooks/useFavicon';

const App: React.FC = () => {
    useFavicon();

    return (
        <MetaProvider>
            <Greetings />
            <LoginSide />
        </MetaProvider>
    );
};

export default App;
